import { uniq } from "lodash-es";

import { VALID_AUDIO_FILE_EXTS, VALID_VIDEO_FILE_EXTS } from "../constants";

export const MAX_FILE_UPLOAD_SIZE_BYTES = 1e9; // 1 GB
export const VALID_FILE_EXTS = uniq([
  ...VALID_AUDIO_FILE_EXTS,
  ...VALID_VIDEO_FILE_EXTS,
]).join(", ");
